;(function () {
	const MOBILE_BREAKPOINT = 750
	const swiperInstances = new Map()

	const addSlideClasses = (track) => {
		track.querySelectorAll('.prodotti-in-evidenza__item').forEach((item) => {
			item.classList.add('swiper-slide')
		})
	}

	const destroySlider = (sectionId, track) => {
		const swiper = swiperInstances.get(sectionId)
		if (swiper && typeof swiper.destroy === 'function') {
			swiper.destroy(true, true)
			swiperInstances.delete(sectionId)
		}

		track.querySelectorAll('.prodotti-in-evidenza__item').forEach((item) => {
			item.removeAttribute('style')
			item.classList.remove('swiper-slide')
		})
	}

	const initSlider = (sectionId, track) => {
		if (swiperInstances.has(sectionId) || typeof Swiper === 'undefined') return

		const swiper = new Swiper(track, {
			loop: false,
			slidesPerView: 1.15,
			spaceBetween: 0,
		})

		swiperInstances.set(sectionId, swiper)
	}

	const syncSection = (section) => {
		const sectionId = section.dataset.sectionId
		const track = section.querySelector('.swiper--prodotti-in-evidenza')
		if (!sectionId || !track) return

		if (section.offsetWidth < MOBILE_BREAKPOINT) {
			addSlideClasses(track)
			initSlider(sectionId, track)
		} else {
			destroySlider(sectionId, track)
		}
	}

	const initProdottiInEvidenza = () => {
		document.querySelectorAll('.prodotti-in-evidenza').forEach((section) => {
			syncSection(section)

			if (section.dataset.resizeObserved === 'true') return
			section.dataset.resizeObserved = 'true'

			const observer = new ResizeObserver(() => {
				syncSection(section)
			})
			observer.observe(section)
		})
	}

	initProdottiInEvidenza()

	document.addEventListener('shopify:section:load', initProdottiInEvidenza)
	document.addEventListener('shopify:section:unload', (event) => {
		const section = event.target.querySelector('.prodotti-in-evidenza')
		if (!section) return

		const sectionId = section.dataset.sectionId
		const track = section.querySelector('.swiper--prodotti-in-evidenza')
		if (sectionId && track) {
			destroySlider(sectionId, track)
		}
	})
})()
